<mat-progress-bar
    mode="indeterminate"
    [appVisible]="loadingProjects"
></mat-progress-bar>

<form [formGroup]="searchForm">
    <div
        class="tw-flex tw-row md:tw-grid-cols-3 tw-items-start tw-gap-4 tw-m-4"
    >
        <mat-card
            class="tw-ml-4 tw-max-w-32 tw-flex tw-flex-col tw-gap-2 tw-col-span-5 lg:tw-col-span-4 2xl:tw-col-span-3 lg:tw-col-start-2 2xl:tw-col-start-2 tw-min-w-fit"
        >
            <mat-card-content class="tw-grid tw-grid-flow-row tw-gap-2">
                <div class="tw-flex tw-justify-between tw-gap-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Select Client</mat-label>
                        <mat-select
                            formControlName="clientId"
                            (valueChange)="clientChange()"
                        >
                            @for (client of clients; track $index) {
                                <mat-option [value]="client.id">
                                    {{ client.name }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (searchForm.controls.clientId.value) {
                        <button
                            class="tw-mt-2"
                            mat-raised-button
                            (click)="
                                onClientRoute(
                                    searchForm.controls.clientId.value
                                )
                            "
                        >
                            View Client Details
                        </button>
                    }
                </div>
                <div class="tw-flex tw-justify-between">
                    <mat-slide-toggle
                        class="tw-content-center"
                        (change)="toggleActiveInactive()"
                        [checked]="projectStatus"
                    >
                        @if (projectStatus) {
                            Active
                        } @else {
                            Inactive
                        }
                    </mat-slide-toggle>
                </div>
                <div>
                    <mat-form-field subscriptSizing="dynamic" class="tw-w-full">
                        <mat-label>Search Projects</mat-label>
                        <input matInput type="text" formControlName="search" />
                    </mat-form-field>
                </div>
                <mat-selection-list
                    #projectSelectionList
                    hideSingleSelectionIndicator
                    class="scrollable"
                    multiple="false"
                    (selectionChange)="projectSelectionChange($event)"
                >
                    @for (project of page.items; track project) {
                        <mat-list-option [value]="project">
                            {{ project.name }}
                        </mat-list-option>
                        @if (!$last) {
                            <mat-divider></mat-divider>
                        }
                    }
                </mat-selection-list>
            </mat-card-content>
            <mat-card-actions class="tw-ml-auto">
                <mat-paginator
                    class="tw-bg-transparent"
                    [pageIndex]="pageIndex"
                    [pageSize]="page.countRequested"
                    [length]="page.totalCount"
                    [hidePageSize]="true"
                    (page)="changePage($event)"
                ></mat-paginator>
            </mat-card-actions>
        </mat-card>

        <div class="tw-col-span-5 lg:tw-col-span-4 2xl:tw-col-span-5">
            <app-staff-utilization-view />
        </div>
    </div>
</form>
